import React, { useState , useEffect } from "react";
import { fetchData } from "../Components/common/utils";
function ContactUs() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        msg: "",
    });

    const [errors, setErrors] = useState({});
    const [newDetail, setNewDetail] = useState({});
    const [isLoading, setIsLoading] = useState(false);
      useEffect(() => {
    const fetchApiData = async () => {
      const url = "api/address";
      const result = await fetchData(url);
      if (result && result.data) {
        setNewDetail(result.data)
      }
    };

    fetchApiData();
  }, []);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.name.trim()) newErrors.name = "Name is required";
        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Invalid email format";
        }
        if (!formData.subject.trim()) newErrors.subject = "Subject is required";
        if (!formData.msg.trim()) newErrors.msg = "msg is required";
        return newErrors;
    };

    const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return;
    }

    setErrors({});
    setIsLoading(true)
    try {
        const response = await fetch("https://admin.energybazzar.com/api/contact/us", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        });

        const result = await response.json();
        setIsLoading(false)
        if (response.ok) {
            alert("Your request submitted successfully!");

            // Reset form
            setFormData({
                name: "",
                email: "",
                subject: "",
                msg: "",
            });
        } else {
            setIsLoading(false)
            alert("Failed to submit request");
            console.error("API Error:", result);
        }
    } catch (error) {
        setIsLoading(false)
        alert("An error occurred while submitting the request");
        console.error("Network error:", error);
    }
};
    return (
        <div>
            <section className="page-top-section text-center">
                <div className="container">
                    <div className="page-header">
                        <h1>Contact Us</h1>
                    </div>
                </div>
            </section>


            <section className="page-section color mt-4 mb-4">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="contact-info">
                                <h2 className="block-title"><span>Contact Us</span></h2>

                                <div className="media-list">
                                    <div className="media">
                                        <i className="pull-left fa fa-home"></i>
                                        <div className="media-body">
                                            <strong>Address:</strong><br />
                                            {newDetail?.address}
                                        </div>
                                    </div>
                                    <div className="media mt-4">
                                        <i className="pull-left fa fa-phone"></i>
                                        <div className="media-body">
                                            <strong>Telephone:</strong><br />
                                            {newDetail?.telephone}
                                        </div>
                                    </div>
                                    <div className="media mt-4">
                                        <i className="pull-left fa fa-envelope-o"></i>
                                        <div className="media-body">
                                            <strong>Fax:</strong><br />
                                            {newDetail?.fax}
                                        </div>
                                    </div>
                                   
                                    <div className="media mt-4">
                                        <div className="media-body">
                                            <strong>Customer Service:</strong><br />
                                            <a href={`mailto:${newDetail?.customer_service}`}>{newDetail?.customer_service}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-8 text-left">
                            <h2 className="block-title"><span>Contact Form</span></h2>

                            <div className="contact-form">
                                <div className="form-group mt-2">
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Name"
                                        className="form-control"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                    {errors.name && <small className="text-danger">{errors.name}</small>}
                                </div>

                                <div className="form-group mt-2">
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Email"
                                        className="form-control"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                    {errors.email && <small className="text-danger">{errors.email}</small>}
                                </div>

                                <div className="form-group mt-2">
                                    <input
                                        type="text"
                                        name="subject"
                                        placeholder="Subject"
                                        className="form-control"
                                        value={formData.subject}
                                        onChange={handleChange}
                                    />
                                    {errors.subject && <small className="text-danger">{errors.subject}</small>}
                                </div>

                                <div className="form-group mt-2">
                                    <textarea
                                        name="msg"
                                        placeholder="Message"
                                        rows="4"
                                        className="form-control"
                                        value={formData.msg}
                                        onChange={handleChange}
                                    />
                                    {errors.msg && <small className="text-danger">{errors.msg}</small>}
                                </div>

                                <button disabled={isLoading} onClick={handleSubmit} type="submit" className="btn btn-primary mt-3">
                                    {isLoading ? 'Please Wait...' : 'Submit'}
                                    </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div style={{ width: '100%' }}>
                <iframe
                    width="100%"
                    height="600"
                    frameBorder="0"
                    scrolling="no"
                    marginHeight="0"
                    marginWidth="0"
                    src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Johar%20town%20lahore+(Solar%20Energy)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                    title="Google Map"
                ></iframe>
            </div>
        </div>
    );
}

export default ContactUs;
